import { toDisplayLong, isEventOrganizer } from '../helpers';

function EventCard({ ev, venues, currentUser, onSelect, past=false, defaultVenueBg=null }) {
  const venue = venues.find(v => v.id === ev.venue_id);
  const isOrganizer = isEventOrganizer(ev, currentUser.id);
  const isParticipant = (ev.event_participants||[]).some(p => p.musician_id === currentUser.id);
  const partCount = (ev.event_participants||[]).length;
  const trackCount = (ev.tracks||[]).filter(t => t.type !== 'free').length;
  const locationName = venue ? venue.name : ev.location_name || ev.location || '';
  const locationDetail = [ev.city || venue?.city, venue?.address || ev.location].filter(Boolean).join(' · ');

  const badge = past ? <Badge color="muted">Conclusa</Badge>
    : isOrganizer ? <Badge color="cyan">Organizzi</Badge>
    : isParticipant ? <Badge color="success">Ci sei</Badge>
    : ev.visibility === 'private' ? <Badge color="muted">Privata</Badge>
    : ev.visibility === 'request' ? <Badge color="purple">Su richiesta</Badge>
    : null;

  const counters = [
    partCount > 0 ? `${partCount} ${partCount === 1 ? 'musicista' : 'musicisti'}` : null,
    trackCount > 0 ? `${trackCount} ${trackCount === 1 ? 'pezzo' : 'pezzi'}` : null,
  ].filter(Boolean).join(' · ');

  return (
    <div
      onClick={() => onSelect(ev)}
      style={{
        background: 'var(--surface)',
        border: `1px solid ${past ? 'rgba(237,77,29,0.15)' : 'rgba(237,77,29,0.3)'}`,
        borderRadius: 16,
        overflow: 'hidden',
        marginBottom: 10,
        cursor: 'pointer',
        opacity: past ? 0.6 : 1,
        transition: 'border-color .15s, transform .15s',
      }}
      onMouseEnter={e => { e.currentTarget.style.borderColor = 'rgba(237,77,29,0.6)'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
      onMouseLeave={e => { e.currentTarget.style.borderColor = past ? 'rgba(237,77,29,0.15)' : 'rgba(237,77,29,0.3)'; e.currentTarget.style.transform = 'translateY(0)'; }}
    >
      <div style={{ height: 3, background: past ? '#2A2622' : (isOrganizer||isParticipant) ? '#ED4D1D' : 'rgba(237,77,29,0.18)' }}/>

      <div style={{ padding: '14px 16px' }}>
        {/* Titolo */}
        <div style={{ fontSize: 18, fontWeight: 800, color: (isOrganizer||isParticipant)&&!past ? '#E8DDD0' : '#B5AA9A', lineHeight: 1.2, marginBottom: 4 }}>
          {ev.title}
        </div>

        {/* Data */}
        <div style={{ fontSize: 16, fontWeight: 700, color: 'var(--muted)', marginBottom: 4 }}>
          {toDisplayLong(ev.date)}{ev.time_start ? ` · ${ev.time_start}${ev.time_end ? ` → ${ev.time_end}` : ''}` : ''}
        </div>

        {/* Venue */}
        {locationName && <div style={{ fontSize: 16, fontWeight: 700, color: 'var(--text)', marginBottom: 1 }}>{locationName}</div>}
        {locationDetail && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 12 }}>
            <span style={{ fontSize: 16, color: 'var(--muted)', flex: 1 }}>{locationDetail}</span>
            <button
              onClick={e => {
                e.stopPropagation();
                const addr = venue?.address || ev.location || '';
                const city = ev.city || venue?.city || '';
                if (addr || city) window.open(`https://maps.google.com/?q=${encodeURIComponent([addr,city].filter(Boolean).join(', '))}`);
              }}
              style={{flexShrink:0,fontSize:17,padding:"2px 10px",borderRadius:999,background:"rgba(237,77,29,0.06)",border:"1px solid rgba(237,77,29,0.2)",color:"var(--brand)",fontWeight:700,cursor:"pointer"}}
            >Mappa</button>
          </div>
        )}

        {/* Footer: badge a sinistra, contatori a destra */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>{badge}</div>
          {counters && <span style={{ fontSize: 16, color: 'var(--muted)' }}>{counters}</span>}
        </div>
      </div>
    </div>
  );
}

function Badge({ color, children }) {
  const styles = {
    cyan:   { bg: 'rgba(237,77,29,.08)',    border: 'rgba(237,77,29,.25)',  text: 'var(--brand)' },
    success:{ bg: 'rgba(237,77,29,.1)',     border: 'rgba(237,77,29,.3)',   text: 'var(--success)' },
    purple: { bg: 'rgba(237,77,29,.12)',   border: 'rgba(237,77,29,.3)',  text: '#ED4D1D' },
    muted:  { bg: 'rgba(237,77,29,0.08)', border: 'rgba(237,77,29,0.2)', text: 'var(--muted)' },
  };
  const s = styles[color] || styles.muted;
  return (
    <span style={{ fontSize: 16, padding: '2px 8px', borderRadius: 999, background: s.bg, border: `1px solid ${s.border}`, color: s.text, fontWeight: 700, whiteSpace: 'nowrap' }}>
      {children}
    </span>
  );
}

export default EventCard;
